<section class="bg-[#f3f3f3] px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">

    <!-- Back navigation -->
    <button (click)="navigateBack()"
      class="mb-3 flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-[#D31148] transition-colors">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
      Back
    </button>

    <ng-container *ngIf="!isLoading && !hasError && blogDetails; else loading">
      <div class="flex flex-col lg:flex-row rounded-2xl border border-[#e6e6e6] bg-white shadow-sm overflow-hidden
                  lg:h-[calc(100vh-160px)] h-[calc(100vh-105px)]">

        <!-- ══════════════════════════════════════════════════════════ -->
        <!-- LEFT: Blog content                                         -->
        <!-- ══════════════════════════════════════════════════════════ -->
        <div class="relative w-full lg:w-[60%] flex-shrink-0 bg-white
                    rounded-t-2xl lg:rounded-l-2xl lg:rounded-tr-none
                    h-72 sm:h-96 lg:h-full" style="overflow: visible;">
          <div class="h-full overflow-y-auto px-5 py-6 space-y-5">

            <!-- ── Removed-by-admin banner (only ever present for the blog's own author) ── -->
            <div *ngIf="blogDetails[0].isRemovedByAdmin"
              class="mx-7 flex items-center gap-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs font-medium px-3 py-2">
              <svg class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
              <!-- Admin opened this from the admin panel (preview link) -->
              <span *ngIf="isAdminPreview; else removedOwnerText">Removed by admin — hidden from other users. Only the author can still see it.</span>
              <ng-template #removedOwnerText>
                <span>This content has been removed by admin and is only visible to you.</span>
              </ng-template>
            </div>

            <!-- ── Collaboration invite banner ── -->
            <div *ngIf="myCollabStatus === 'PENDING'"
              class="mx-7 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 flex flex-col gap-2.5">
              <div class="flex items-start gap-3">
                <div class="flex-shrink-0 w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-semibold text-amber-800">Collaboration Invite</p>
                  <p class="text-xs text-amber-700 mt-0.5 leading-snug">
                    You've been invited to collaborate on this blog. Accept to appear as a co-creator.
                  </p>
                </div>
              </div>
              <div class="flex gap-2">
                <button (click)="acceptCollaboration()" [disabled]="isCollabActioning"
                  class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#D31148] text-white text-sm font-semibold disabled:opacity-50 hover:bg-[#b50e3c] transition-colors">
                  <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <svg *ngIf="isCollabActioning" class="animate-spin" width="14" height="14" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                  </svg>
                  Accept
                </button>
                <button (click)="declineCollaboration()" [disabled]="isCollabActioning"
                  class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl border border-gray-200 bg-white text-gray-600 text-sm font-semibold disabled:opacity-50 hover:bg-gray-50 transition-colors">
                  <svg *ngIf="!isCollabActioning" width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                  Decline
                </button>
              </div>
            </div>

            <!-- ── Collaboration accepted confirmation ── -->
            <div *ngIf="myCollabStatus === 'ACCEPTED'"
              class="mx-7 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 flex items-center gap-3">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <p class="text-sm font-medium text-emerald-800">You are a collaborator on this blog.</p>
            </div>

            <h1 class="text-2xl font-bold text-gray-900 leading-snug break-words">
              {{ blogDetails[0].title }}
            </h1>

            <!-- Blog blocks — rendered with full rich HTML preserved -->
            <div class="space-y-5">
              <ng-container *ngFor="let block of blogDetails[0].blocks">

                <!-- TEXT block — rendered as trusted HTML (tables, code, blockquotes, etc.) -->
                <div *ngIf="block.type === 'TEXT'" class="blog-prose w-full max-w-none text-gray-700 leading-relaxed"
                  [innerHTML]="getSafeHtml(block.html ?? '')">
                </div>

                <!-- IMAGE block -->
                <img *ngIf="block.type === 'IMAGE'" [src]="block.url" class="w-full rounded-xl border border-gray-100"
                  alt="Blog image" />

                <!-- VIDEO block -->
                <video *ngIf="block.type === 'VIDEO'" [src]="block.url" controls
                  class="w-full rounded-xl border border-gray-100">
                </video>

              </ng-container>
            </div>

            <!-- Hashtags -->
            <div *ngIf="blogDetails[0].hashtags.length" class="flex flex-wrap gap-2 pt-2">
              <span *ngFor="let tag of blogDetails[0].hashtags" (click)="goToHashtag(tag, $event)"
                class="text-sm font-semibold text-[#D31148] hover:underline cursor-pointer">#{{ tag
                }}</span>
            </div>

          </div>

        </div>

        <!-- ══════════════════════════════════════════════════════════ -->
        <!-- RIGHT: Comments panel                                      -->
        <!-- ══════════════════════════════════════════════════════════ -->
        <div id="blog-comments-panel" class="flex-1 flex flex-col bg-white border-t lg:border-t-0 lg:border-l border-gray-100
                    rounded-b-2xl lg:rounded-r-2xl lg:rounded-bl-none overflow-hidden min-w-0">

          <!-- Author header -->
          <div class="flex items-center justify-between px-4 sm:px-5 py-3.5 border-b border-gray-100 flex-shrink-0">
            <div class="flex items-center gap-3 min-w-0">
              <div class="flex-shrink-0">
                <!-- No collaborators: single avatar -->
                <img *ngIf="blogDetails[0].acceptedCollaborators.length === 0" [src]="blogDetails[0].hostAvatar"
                  [alt]="blogDetails[0].hostName" class="w-12 h-12 rounded-full object-cover ring-2 ring-[#FFD4E0]"
                  onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

                <!-- Has collaborators: stacked avatars -->
                <div *ngIf="blogDetails[0].acceptedCollaborators.length > 0"
                  class="flex -space-x-2 items-center cursor-pointer"
                  (click)="showCollaboratorsModal(blogDetails[0]); $event.stopPropagation()">
                  <img class="h-11 w-11 rounded-full border-2 border-white object-cover ring-2 ring-[#FFD4E0]"
                    [src]="blogDetails[0].hostAvatar" [alt]="blogDetails[0].hostName"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                  <img class="h-8 w-8 rounded-full border-2 border-white object-cover"
                    [src]="blogDetails[0].acceptedCollaborators[0].profileImage?.urlSmall"
                    [alt]="blogDetails[0].acceptedCollaborators[0].displayName"
                    onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                </div>
              </div>
              <div class="min-w-0">
                <div class="flex items-center gap-2 flex-wrap">
                  <div class="font-bold text-gray-900 text-md truncate">
                    <span (click)="$event.stopPropagation()"
                      [routerLink]="['/profile', blogDetails[0].hostName, 'blog']" class="cursor-pointer">{{
                      blogDetails[0].hostName }}</span>

                    <ng-container *ngIf="blogDetails[0].acceptedCollaborators.length === 1">
                      <span class="font-normal text-gray-500"> with </span>
                      <span class="font-semibold text-gray-700 cursor-pointer" (click)="$event.stopPropagation()"
                        [routerLink]="['/profile', blogDetails[0].acceptedCollaborators[0].userName, 'blog']">{{
                        blogDetails[0].acceptedCollaborators[0].userName }}</span>
                    </ng-container>

                    <ng-container *ngIf="blogDetails[0].acceptedCollaborators.length >= 2">
                      <span class="font-normal text-gray-500"> and </span>
                      <span class="cursor-pointer font-semibold text-gray-700 hover:text-gray-900"
                        (click)="showCollaboratorsModal(blogDetails[0]); $event.stopPropagation()">
                        {{ blogDetails[0].acceptedCollaborators.length }} others
                      </span>
                    </ng-container>
                  </div>

                  <!-- Friend button — hidden when collaborators exist -->
                  <button *ngIf="!blogDetails[0].isMyBlog && blogDetails[0].acceptedCollaborators.length === 0"
                    (click)="onFriendButtonClick(blogDetails[0], $event)"
                    [disabled]="blogDetails[0].friendshipStatus === 'BLOCKED'"
                    [title]="friendButtonTitle(blogDetails[0].friendshipStatus)"
                    class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">
                    <svg *ngIf="blogDetails[0].friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24"
                      fill="none" stroke="#D31148" stroke-width="2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <line x1="19" y1="8" x2="19" y2="14" />
                      <line x1="22" y1="11" x2="16" y2="11" />
                    </svg>
                    <svg *ngIf="blogDetails[0].friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24"
                      fill="none" stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <line x1="17" y1="8" x2="23" y2="14" />
                      <line x1="23" y1="8" x2="17" y2="14" />
                    </svg>
                    <svg *ngIf="blogDetails[0].friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6"
                      viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <polyline points="16 11 18 13 22 9" />
                    </svg>
                    <svg *ngIf="blogDetails[0].friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24"
                      fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <polyline points="16 11 18 13 22 9" />
                    </svg>
                    <svg *ngIf="blogDetails[0].friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24"
                      fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                    </svg>
                  </button>
                </div>
                <span class="text-sm text-gray-400">{{ blogDetails[0].timeAgo }}</span>
              </div>
            </div>

            <!-- Follow / Edit / Three-dot menu -->
            <div class="flex items-center gap-2 flex-shrink-0 ml-2">
              <button *ngIf="!blogDetails[0].isMyBlog" (click)="reportBlog()"
                class="hidden sm:block px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold text-gray-600 hover:bg-gray-50 transition-all whitespace-nowrap">
                Report this Blog
              </button>
              <button
                *ngIf="!blogDetails[0].isMyBlog && !blogDetails[0].isFollowed && blogDetails[0].acceptedCollaborators.length === 0"
                (click)="onBlogFollowClick($event)"
                class="px-4 py-1.5 rounded-lg text-xs font-bold transition-colors shadow-sm bg-[#D31148] text-white hover:bg-[#b80e3d]">
                Follow
              </button>
              <!-- Three-dot action menu (all non-owner viewers get Follow/Unfollow,
                   Report and Block here too, not just followers/collaborators —
                   mirrors the listing page's card menu) -->
              <div class="relative inline-block">
                <button (click)="toggleActionMenu($event)"
                  class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors text-gray-500">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z" />
                  </svg>
                </button>
                <app-dropdown [isOpen]="showActionMenu" (close)="closeActionMenu()" className="w-44 p-2 right-0">
                  <!-- Author actions -->
                  <ng-container *ngIf="blogDetails[0].isMyBlog">
                    <app-dropdown-item (itemClick)="toggleComments(); closeActionMenu()"
                      [className]="(blogDetails[0].commentsDisabled ? 'flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2' : 'flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2') + (togglingComments ? ' opacity-50 pointer-events-none' : '')">
                      <svg *ngIf="!blogDetails[0].commentsDisabled" width="16" height="16" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="flex-shrink-0">
                        <path
                          d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                      </svg>
                      <svg *ngIf="blogDetails[0].commentsDisabled" width="16" height="16" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" class="flex-shrink-0">
                        <path
                          d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                        <line x1="2" y1="2" x2="22" y2="22" />
                      </svg>
                      {{ blogDetails[0].commentsDisabled ? 'Turn on comments' : 'Turn off comments' }}
                    </app-dropdown-item>
                    <app-dropdown-item (itemClick)="editBlog(); closeActionMenu()"
                      className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                      Edit Blog
                    </app-dropdown-item>
                    <app-dropdown-item (itemClick)="confirmDelete(); closeActionMenu()"
                      className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                      </svg>
                      Delete Blog
                    </app-dropdown-item>
                  </ng-container>
                  <!-- Collaborator-only -->
                  <ng-container *ngIf="!blogDetails[0].isMyBlog && isCollaborator">
                    <app-dropdown-item (itemClick)="confirmLeave(); closeActionMenu()"
                      className="flex w-full font-normal text-left text-orange-500 rounded-lg hover:bg-orange-50 hover:text-orange-700 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1="21" y1="12" x2="9" y2="12" />
                      </svg>
                      Leave Collaboration
                    </app-dropdown-item>
                  </ng-container>
                  <!-- Non-owner actions (Follow/Unfollow always available here too,
                       plus Report and Block — same set the listing card offers) -->
                  <ng-container *ngIf="!blogDetails[0].isMyBlog && !isCollaborator">
                    <app-dropdown-item
                      *ngIf="!blogDetails[0].isFollowed && blogDetails[0].acceptedCollaborators.length === 0"
                      (itemClick)="onBlogFollowClick(); closeActionMenu()"
                      className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <line x1="20" y1="8" x2="20" y2="14" />
                        <line x1="17" y1="11" x2="23" y2="11" />
                      </svg>
                      Follow
                    </app-dropdown-item>
                    <app-dropdown-item
                      *ngIf="blogDetails[0].isFollowed && blogDetails[0].acceptedCollaborators.length === 0"
                      (itemClick)="onBlogFollowClick(); closeActionMenu()"
                      className="flex w-full font-normal text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <line x1="17" y1="11" x2="23" y2="11" />
                      </svg>
                      Unfollow
                    </app-dropdown-item>
                    <app-dropdown-item (itemClick)="reportBlog()"
                      className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                      </svg>
                      Report Blog
                    </app-dropdown-item>
                    <app-dropdown-item (itemClick)="blockBlogUser()"
                      className="flex w-full font-normal text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700 px-3 py-2 gap-2">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                      </svg>
                      Block User
                    </app-dropdown-item>
                  </ng-container>
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- Comments section header -->
          <div class="flex items-center justify-between border-b border-gray-100 px-5 py-3 flex-shrink-0">
            <div class="flex items-center gap-2">
              <span class="text-sm font-semibold text-[#000000]">Comments</span>
              <span *ngIf="commentsTotal > 0" class="inline-flex items-center justify-center min-w-[18px] h-[18px]
                           px-1 rounded-full bg-[#000000] text-white text-[10px] font-bold">
                {{ commentsTotal }}
              </span>
            </div>

            <!-- Reaction / share / comment counts + favourite star -->
            <div class="flex items-center gap-4">
              <!-- Tagged people -->
              <button *ngIf="blogDetails[0].mentions.length > 0" type="button"
                (click)="showTaggedPeopleModal(blogDetails[0], $event)" title="Tagged people"
                class="flex items-center justify-center w-7 h-7 rounded-full hover:bg-[#FFF0F3] transition-colors text-gray-500 text-[#D31148]">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </button>
              <!-- Reaction -->
              <div class="relative flex items-center gap-1" style="overflow: visible;">
                <div *ngIf="blogDetails[0].showEmojiPicker" class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white
                         px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100 whitespace-nowrap"
                  style="top: calc(100% + 10px); right: 0; pointer-events: auto;"
                  (mouseleave)="closeEmojiPicker(blogDetails[0])">
                  <button *ngFor="let r of REACTIONS; let i = index"
                    (click)="onEmojiPick(blogDetails[0], r.type, $event)"
                    (mouseenter)="blogDetails[0].hoveredReaction = r.type"
                    (mouseleave)="blogDetails[0].hoveredReaction = null"
                    class="flex flex-col items-center cursor-pointer" [style.animation-delay.ms]="i * 30"
                    [title]="r.label">
                    <span class="flex items-center justify-center rounded-full transition-transform duration-150"
                      [style.background]="r.bg" [class.scale-125]="blogDetails[0].hoveredReaction === r.type"
                      [class.-translate-y-2]="blogDetails[0].hoveredReaction === r.type"
                      style="width:36px;height:36px;font-size:20px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                      {{ r.emoji }}
                    </span>
                  </button>
                </div>
                <button
                  class="flex items-center justify-center w-7 h-7 rounded-full hover:bg-[#FFF0F3] transition-colors"
                  (click)="onReactionClick(blogDetails[0])">
                  <ng-container *ngIf="!blogDetails[0].myReaction">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D31148" stroke-width="1.8"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7 10v12" />
                      <path
                        d="M15 5.88L14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="blogDetails[0].myReaction">
                    <span class="flex items-center justify-center rounded-full hover:scale-110 transition-transform"
                      [style.background]="getReactionConfig(blogDetails[0].myReaction)?.bg"
                      style="width:24px;height:24px;font-size:14px;line-height:1;">
                      {{ getReactionConfig(blogDetails[0].myReaction)?.emoji }}
                    </span>
                  </ng-container>
                </button>
                <span class="text-xs font-semibold"
                  [style.color]="blogDetails[0].myReaction ? getReactionConfig(blogDetails[0].myReaction)?.color : '#4b5563'">
                  {{ blogDetails[0].totalReactions }}
                </span>
              </div>



              <!-- Share -->
              <button class="flex items-center gap-1 group" (click)="openShareSheet()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <g opacity="0.7">
                    <path
                      d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                      stroke="#D31148" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </svg>
                <span class="text-xs font-semibold text-gray-600">{{ blogDetails[0].shares }}</span>
              </button>

              <!-- Comment count -->
              <div class="flex items-center gap-1">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#D31148" stroke-width="1.8"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <span class="text-xs font-semibold text-gray-600">{{ blogDetails[0].comments }}</span>
              </div>

              <!-- Favourite star -->
              <button (click)="toggleFavourite()" [class.text-[#D31148]]="isFavourite"
                [class.text-gray-300]="!isFavourite"
                [title]="isFavourite ? 'Remove from favourites' : 'Save to favourites'"
                class="flex items-center justify-center transition-colors hover:text-[#D31148]">
                <svg class="w-5 h-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" [attr.fill]="isFavourite ? 'currentColor' : 'none'">
                  <polygon
                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Comments body -->
          <div class="flex-1 flex flex-col min-h-0 overflow-hidden">

            <!-- Scrollable comment list -->
            <div class="flex-1 overflow-y-auto min-h-0 px-4 sm:px-5 py-4 space-y-5">

              <!-- Loading skeleton -->
              <ng-container *ngIf="commentsLoading && !commentsLoaded">
                <div *ngFor="let s of [1,2,3]" class="flex gap-3 animate-pulse">
                  <div class="w-9 h-9 rounded-full bg-gray-200 flex-shrink-0"></div>
                  <div class="flex-1 space-y-2">
                    <div class="h-3 bg-gray-200 rounded w-32"></div>
                    <div class="h-3 bg-gray-200 rounded w-full"></div>
                    <div class="h-3 bg-gray-200 rounded w-3/4"></div>
                  </div>
                </div>
              </ng-container>

              <!-- Empty state -->
              <div *ngIf="!commentsLoading && commentsLoaded && comments.length === 0"
                class="flex flex-col items-center justify-center py-12 text-center">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D31148" stroke-width="1.3"
                  stroke-linecap="round" stroke-linejoin="round" class="opacity-30 mb-3">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
                <p class="text-sm text-gray-400 font-medium">No comments yet</p>
                <p class="text-xs text-gray-400 mt-0.5">Be the first to join the conversation</p>
              </div>

              <!-- Comment list -->
              <ng-container *ngFor="let comment of comments">
                <div class="flex gap-3">
                  <img [src]="getUserAvatar(comment)" [alt]="comment.user.displayName"
                    (click)="$event.stopPropagation()" [routerLink]="['/profile', comment.user.userName, 'blog']"
                    class="w-9 h-9 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
                  <div class="flex-1 min-w-0">

                    <!-- Comment header -->
                    <div class="flex items-center justify-between mb-1 gap-2">
                      <div class="flex items-center gap-2 min-w-0">
                        <span class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                          (click)="$event.stopPropagation()"
                          [routerLink]="['/profile', comment.user.userName, 'blog']">{{ comment.user.userName }}</span>
                        <span class="text-xs text-gray-400 whitespace-nowrap">{{ getTimeAgo(comment.createdAt) }}</span>
                        <span *ngIf="comment.isEdited" class="text-[10px] text-gray-400 italic">(edited)</span>
                      </div>
                      <div class="flex items-center gap-2 flex-shrink-0">
                        <button *ngIf="comment.ableToReply && !blogDetails[0].commentsDisabled"
                          (click)="toggleReply(comment._id)" class="text-xs font-semibold transition-colors"
                          [class.text-[#D31148]]="replyingTo === comment._id"
                          [class.text-gray-500]="replyingTo !== comment._id">
                          Reply
                        </button>
                        <ng-container *ngIf="comment.ableToModification || canReportComment(comment)">
                          <div class="relative inline-block">
                            <button class="dropdown-toggle"
                              (click)="toggleDropdown(comment._id); $event.stopPropagation()">
                              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                                class="text-gray-400 hover:text-gray-700 size-6">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                  fill="currentColor" />
                              </svg>
                            </button>
                            <app-dropdown [isOpen]="openDropdownId === comment._id" (close)="closeDropdown()"
                              className="w-40 p-2">
                              <ng-container *ngIf="comment.ableToModification; else reportCommentItem">
                                <app-dropdown-item (itemClick)="startEdit(comment); closeDropdown()"
                                  className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                  Edit
                                </app-dropdown-item>
                                <app-dropdown-item (itemClick)="deleteComment(comment._id); closeDropdown()"
                                  className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                  Delete
                                </app-dropdown-item>
                              </ng-container>
                              <ng-template #reportCommentItem>
                                <app-dropdown-item (itemClick)="reportComment(comment._id)"
                                  className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                  Report
                                </app-dropdown-item>
                              </ng-template>
                            </app-dropdown>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <!-- Edit mode -->
                    <ng-container *ngIf="editingCommentId === comment._id; else commentBody">
                      <div class="flex gap-2 mt-1 items-center">
                        <button (click)="toggleEmojiPicker($event, 'main')"
                          class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0">
                          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                            <line x1="9" y1="9" x2="9.01" y2="9" />
                            <line x1="15" y1="9" x2="15.01" y2="9" />
                          </svg>
                        </button>
                        <input [(ngModel)]="editInput" type="text"
                          class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                        <button (click)="saveEdit(comment)" [disabled]="submitting" class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
                                       hover:bg-[#b80e3d] transition-colors disabled:opacity-50">Save</button>
                        <button (click)="cancelEdit()" class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
                                       text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                      </div>
                    </ng-container>

                    <!-- Comment body — rich HTML preserved -->
                    <ng-template #commentBody>
                      <div *ngIf="getTextPart(comment.body)"
                        class="text-sm text-gray-600 leading-relaxed break-words comment-body"
                        [innerHTML]="getSafeHtml(getTextPart(comment.body))">
                      </div>
                      <img *ngIf="getGifPart(comment.body)" [src]="getGifPart(comment.body)" alt="GIF"
                        class="mt-2 rounded-xl max-h-40 object-cover border border-gray-100" />
                    </ng-template>

                    <!-- Reply input -->
                    <div *ngIf="replyingTo === comment._id" [id]="'reply-input-' + comment._id" class="mt-3 relative">
                      <app-mention-dropdown [isOpen]="showMentionDropdown && activeMentionContext === comment._id"
                        [users]="mentionUsers" (selected)="onMentionPicked($event, comment._id, replyDir)">
                      </app-mention-dropdown>
                      <div *ngIf="replyGifUrls[comment._id]" class="mb-2">
                        <div class="relative inline-block">
                          <img [src]="replyGifUrls[comment._id]" alt="Selected GIF"
                            class="h-16 rounded-xl border border-gray-200 object-cover" />
                          <button (click)="removeGif(comment._id)"
                            class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                                         rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
                            ×
                          </button>
                        </div>
                      </div>
                      <div class="flex gap-2">
                        <button (click)="toggleEmojiPicker($event, comment._id)"
                          class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0">
                          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                            <line x1="9" y1="9" x2="9.01" y2="9" />
                            <line x1="15" y1="9" x2="15.01" y2="9" />
                          </svg>
                        </button>
                        <div #replyDir="appMentionInput" appMentionInput contenteditable="true" role="textbox"
                          aria-multiline="false" [attr.data-placeholder]="'Write a reply… type @ to mention'"
                          (mentionEnter)="submitReply(comment._id)"
                          (mentionSearch)="onMentionSearch($event, comment._id)"
                          (mentionDropdown)="onMentionDropdownChange($event, comment._id)"
                          (valueChange)="replyInputs[comment._id] = $event" class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none
                                    border border-gray-200 focus:border-[#D31148] rounded-xl px-3 py-1.5
                                    transition-colors bg-[#f7f7f7]">
                        </div>
                        <button (click)="toggleGifPicker(comment._id, $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148] transition-colors
                                       flex-shrink-0 px-1 leading-none"
                          [class.text-[#D31148]]="showGifPicker && activeEmojiContext === comment._id">
                          GIF
                        </button>
                        <button (click)="submitReply(comment._id)"
                          [disabled]="submitting || (!replyInputs[comment._id]?.trim() && !replyGifUrls[comment._id])"
                          class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148]
                                       text-white hover:bg-[#b80e3d] transition-colors disabled:opacity-50">
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="22" y1="2" x2="11" y2="13" />
                            <polygon points="22 2 15 22 11 13 2 9 22 2" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <!-- Replies -->
                    <ng-container *ngIf="comment.replies && comment.replies.length > 0">
                      <div class="mt-3 pl-3 border-l-2 border-[#FFD4E0] space-y-3">
                        <div *ngFor="let reply of comment.replies" class="flex gap-2.5">
                          <img [src]="getUserAvatar(reply)" [alt]="reply.user.displayName"
                            (click)="$event.stopPropagation()" [routerLink]="['/profile', reply.user.userName, 'blog']"
                            class="w-8 h-8 rounded-full object-cover flex-shrink-0 mt-0.5 cursor-pointer" />
                          <div class="flex-1 min-w-0">
                            <div class="flex items-center justify-between mb-1 gap-2">
                              <div class="flex items-center gap-2 min-w-0">
                                <span class="text-sm font-bold text-gray-900 truncate cursor-pointer"
                                  (click)="$event.stopPropagation()"
                                  [routerLink]="['/profile', reply.user.userName, 'blog']">{{ reply.user.userName
                                  }}</span>
                                <span class="text-xs text-gray-400 whitespace-nowrap">{{ getTimeAgo(reply.createdAt)
                                  }}</span>
                                <span *ngIf="reply.isEdited" class="text-[10px] text-gray-400 italic">(edited)</span>
                              </div>
                              <ng-container *ngIf="reply.ableToModification || canReportComment(reply)">
                                <div class="relative inline-block">
                                  <button class="dropdown-toggle"
                                    (click)="toggleDropdown(reply._id); $event.stopPropagation()">
                                    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"
                                      class="text-gray-400 hover:text-gray-700 size-6">
                                      <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z"
                                        fill="currentColor" />
                                    </svg>
                                  </button>
                                  <app-dropdown [isOpen]="openDropdownId === reply._id" (close)="closeDropdown()"
                                    className="w-40 p-2">
                                    <ng-container *ngIf="reply.ableToModification; else reportReplyItem">
                                      <app-dropdown-item (itemClick)="startEdit(reply); closeDropdown()"
                                        className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                        Edit
                                      </app-dropdown-item>
                                      <app-dropdown-item
                                        (itemClick)="deleteComment(reply._id, comment._id); closeDropdown()"
                                        className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                        Delete
                                      </app-dropdown-item>
                                    </ng-container>
                                    <ng-template #reportReplyItem>
                                      <app-dropdown-item (itemClick)="reportComment(reply._id)"
                                        className="flex w-full font-normal text-left text-gray-500 rounded-lg hover:bg-gray-100 hover:text-gray-700">
                                        Report
                                      </app-dropdown-item>
                                    </ng-template>
                                  </app-dropdown>
                                </div>
                              </ng-container>
                            </div>

                            <!-- Edit mode for reply -->
                            <ng-container *ngIf="editingCommentId === reply._id; else replyBody">
                              <div class="flex gap-2 mt-1">
                                <input [(ngModel)]="editInput" type="text"
                                  class="flex-1 text-sm border border-[#D31148] rounded-lg px-3 py-1.5 outline-none bg-white" />
                                <button (click)="saveEdit(reply)" [disabled]="submitting" class="px-3 py-1.5 rounded-lg bg-[#D31148] text-white text-xs font-bold
                                               hover:bg-[#b80e3d] transition-colors disabled:opacity-50">Save</button>
                                <button (click)="cancelEdit()" class="px-3 py-1.5 rounded-lg border border-gray-200 text-xs font-semibold
                                               text-gray-600 hover:bg-gray-50 transition-colors">Cancel</button>
                              </div>
                            </ng-container>

                            <!-- Reply body — rich HTML preserved -->
                            <ng-template #replyBody>
                              <div *ngIf="getTextPart(reply.body)"
                                class="text-sm text-gray-600 leading-relaxed break-words comment-body"
                                [innerHTML]="getSafeHtml(getTextPart(reply.body))">
                              </div>
                              <img *ngIf="getGifPart(reply.body)" [src]="getGifPart(reply.body)" alt="GIF"
                                class="mt-2 rounded-xl max-h-32 object-cover border border-gray-100" />
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                  </div>
                </div>
              </ng-container>

              <!-- Load more -->
              <div *ngIf="commentsPage < commentsTotalPages" class="flex justify-center pt-2 pb-1">
                <button (click)="loadMoreComments()" [disabled]="commentsLoading"
                  class="text-xs font-semibold text-[#D31148] hover:underline disabled:opacity-50">
                  {{ commentsLoading ? 'Loading…' : 'Load more comments' }}
                </button>
              </div>

            </div><!-- end scrollable list -->

            <!-- ══════════════════════════════════════════════════════ -->
            <!-- Sticky comment footer                                  -->
            <!-- ══════════════════════════════════════════════════════ -->
            <div class="flex-shrink-0 border-t border-gray-100 bg-white comment-picker-area" style="position:relative;">

              <!-- Quick emoji bar -->
              <!-- <div class="flex items-center gap-1 px-3 py-2 overflow-x-auto border-b border-gray-50"
                style="-ms-overflow-style:none;scrollbar-width:none;">
                <button *ngFor="let e of QUICK_EMOJIS" (click)="appendQuickEmoji(e)" class="text-lg flex-shrink-0 w-9 h-9 flex items-center justify-center
                               rounded-full hover:bg-gray-100 hover:scale-125 transition-all">
                  {{ e }}
                </button>
              </div> -->

              <!-- GIF preview strip -->
              <div *ngIf="selectedGifUrl" class="flex items-center gap-2 px-3 pt-2">
                <div class="relative inline-block">
                  <img [src]="selectedGifUrl" alt="Selected GIF"
                    class="h-16 rounded-xl border border-gray-200 object-cover" />
                  <button (click)="removeGif()" class="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center
                                 rounded-full bg-gray-800 text-white text-xs hover:bg-red-500 transition-colors">
                    ×
                  </button>
                </div>
              </div>

              <!-- Comments disabled banner -->
              <div *ngIf="blogDetails[0].commentsDisabled"
                class="mx-3 my-3 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl flex items-center gap-2 text-sm text-gray-500">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                </svg>
                Comments have been turned off for this blog.
              </div>

              <!-- Input row -->
              <div *ngIf="!blogDetails[0].commentsDisabled" class="flex items-center gap-2 px-3 sm:px-4 py-3">
                <img [src]="getCurrentUserAvatar()" alt="me" class="w-8 h-8 rounded-full object-cover flex-shrink-0" />
                <div class="flex-1 relative">

                  <app-mention-dropdown [isOpen]="showMentionDropdown && activeMentionContext === 'main'"
                    [users]="mentionUsers" (selected)="onMentionPicked($event, 'main', mainDir)">
                  </app-mention-dropdown>

                  <div class="flex items-center gap-2 bg-[#f7f7f7] rounded-xl px-3 py-2
                              border border-gray-200 focus-within:border-[#D31148] transition-colors min-w-0">
                    <button (click)="toggleEmojiPicker($event, 'main')"
                      class="text-gray-400 hover:text-[#D31148] transition-colors flex-shrink-0"
                      [class.text-[#D31148]]="showEmojiPicker">
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                        <line x1="9" y1="9" x2="9.01" y2="9" />
                        <line x1="15" y1="9" x2="15.01" y2="9" />
                      </svg>
                    </button>

                    <div #mainDir="appMentionInput" appMentionInput contenteditable="true" role="textbox"
                      aria-multiline="false" [attr.data-placeholder]="'Join the conversation… type @ to mention'"
                      (mentionEnter)="submitComment()" (mentionSearch)="onMentionSearch($event, 'main')"
                      (mentionDropdown)="onMentionDropdownChange($event, 'main')" (valueChange)="commentInput = $event"
                      class="mention-editable comment-mention-input flex-1 text-sm text-gray-700 outline-none min-w-0">
                    </div>

                    <button (click)="toggleGifPicker('main', $event)" class="text-xs font-black text-gray-400 hover:text-[#D31148] transition-colors
                                   flex-shrink-0 px-1 leading-none" [class.text-[#D31148]]="showGifPicker">
                      GIF
                    </button>
                  </div>
                </div>

                <button (click)="submitComment()" [disabled]="submitting || (!commentInput.trim() && !selectedGifUrl)"
                  class="w-8 h-8 flex items-center justify-center rounded-full bg-[#D31148] text-white
                               hover:bg-[#b80e3d] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13" />
                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                  </svg>
                </button>
              </div>

              <!-- Emoji picker panel -->
              <div *ngIf="showEmojiPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                          shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
                <div class="flex border-b border-gray-100 px-2 pt-2 gap-1">
                  <button *ngFor="let cat of EMOJI_CATEGORIES; let i = index" (click)="setEmojiTab(i)"
                    class="px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors"
                    [class.bg-[#D31148]]="activeEmojiTab === i" [class.text-white]="activeEmojiTab === i"
                    [class.text-gray-500]="activeEmojiTab !== i" [class.hover:bg-gray-100]="activeEmojiTab !== i">
                    {{ cat.label }}
                  </button>
                </div>
                <div class="flex flex-wrap gap-0.5 p-3 max-h-40 overflow-y-auto">
                  <button *ngFor="let emoji of EMOJI_CATEGORIES[activeEmojiTab].emojis" (click)="pickEmoji(emoji)"
                    class="text-xl w-9 h-9 flex items-center justify-center rounded-lg
                                 hover:bg-gray-100 hover:scale-110 transition-all">
                    {{ emoji }}
                  </button>
                </div>
              </div>

              <!-- GIF picker panel -->
              <div *ngIf="showGifPicker" class="absolute bottom-full left-0 right-0 mx-3 mb-1 bg-white rounded-2xl border border-gray-200
                          shadow-xl z-[500] overflow-hidden" (click)="$event.stopPropagation()">
                <div class="flex items-center gap-2 p-3 border-b border-gray-100">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <input [(ngModel)]="gifSearchQuery" type="text" placeholder="Search GIFs (powered by GIPHY)…"
                    (keyup)="onGifSearchKey($event)"
                    class="flex-1 text-sm outline-none text-gray-700 placeholder-gray-400 bg-transparent" />
                  <button (click)="searchGifs()"
                    class="text-xs font-bold text-[#D31148] hover:underline">Search</button>
                </div>
                <div class="p-2 max-h-48 overflow-y-auto">
                  <div *ngIf="gifLoading" class="flex items-center justify-center py-8">
                    <div class="w-6 h-6 border-2 border-[#D31148] border-t-transparent rounded-full animate-spin"></div>
                  </div>
                  <div *ngIf="!gifLoading && gifResults.length === 0" class="py-8 text-center text-sm text-gray-400">
                    Search for a GIF above
                  </div>
                  <div *ngIf="!gifLoading && gifResults.length > 0" class="grid grid-cols-3 sm:grid-cols-4 gap-1.5">
                    <button *ngFor="let g of gifResults" (click)="selectGif(g)"
                      class="rounded-xl overflow-hidden hover:ring-2 hover:ring-[#D31148] transition-all aspect-video">
                      <img [src]="g.preview" alt="GIF" class="w-full h-full object-cover" loading="lazy" />
                    </button>
                  </div>
                  <p *ngIf="gifResults.length > 0" class="text-[10px] text-gray-400 text-center pt-2">Powered by GIPHY
                  </p>
                </div>
              </div>

            </div><!-- end sticky footer -->

          </div><!-- end comments body -->
        </div><!-- end right panel -->

      </div>
    </ng-container>

    <!-- ══ Recommendations ══ -->
    <ng-container *ngIf="!isLoading && !hasError && blogDetails">

      <!-- Loading skeleton -->
      <div *ngIf="recsLoading" class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">
        <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="h-8 bg-white/20 rounded w-64 mb-8 animate-pulse"></div>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
            <div *ngFor="let _ of [1,2,3]"
              class="bg-white rounded-2xl overflow-hidden px-4 flex flex-col shadow-md animate-pulse">
              <div class="flex items-center gap-2.5 pt-4 pb-3">
                <div class="w-14 h-14 rounded-full bg-gray-200 flex-shrink-0"></div>
                <div class="flex-1 space-y-2">
                  <div class="h-3 bg-gray-200 rounded w-3/4"></div>
                  <div class="h-3 bg-gray-200 rounded w-1/2"></div>
                </div>
              </div>
              <div class="w-full bg-gray-200" style="aspect-ratio:4/3;"></div>
              <div class="py-3 space-y-2">
                <div class="h-3 bg-gray-200 rounded"></div>
                <div class="h-3 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </ng-container>

    <!-- Loading / error state -->
    <ng-template #loading>
      <div class="flex items-center justify-center min-h-[300px]">
        <div *ngIf="isLoading" class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]">
        </div>
        <div *ngIf="hasError" class="text-center">
          <p class="text-gray-500 font-medium">Failed to load blog.</p>
          <button (click)="blogId && getBlog(blogId)" class="mt-2 text-sm text-[#D31148] hover:underline">Try
            again</button>
        </div>
      </div>
    </ng-template>

  </div>
</section>
<!-- Actual recommendations — exact document 8 design, data from API -->
<!-- <section *ngIf="!recsLoading && recommendations.length > 0"
  class="relative w-full overflow-hidden py-10 sm:py-14 md:py-16">
  <div class="absolute inset-0 z-0">
    <img src="/images/blog-bg.png" alt="" class="w-full h-full object-cover object-center" />
  </div>
  <div class="relative z-10 w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between mb-6 sm:mb-8">
      <h2 class="text-white font-bold text-xl sm:text-2xl md:text-3xl tracking-tight">
        Recommended for you
      </h2>
      <a href="#"
        class="flex items-center gap-1.5 text-white text-sm sm:text-base font-medium hover:text-[#e0144c] transition-colors duration-200 whitespace-nowrap">
        View all
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </a>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
      <div *ngFor="let blog of recommendations; trackBy: trackById; let i = index"
        class="bg-white rounded-2xl overflow-hidden px-4 flex flex-col shadow-md transition-all duration-250 hover:-translate-y-1 hover:shadow-xl cursor-pointer"
        style="height: fit-content;" [style.animation-delay]="(i * 0.1 + 0.05) + 's'"
        [style.animation]="'fadeUp 0.6s ease-out both'" (click)="navigateToRecommendation(blog._id)">

        <div class="flex items-center justify-between pt-4 pb-3">
          <div class="flex items-center gap-2.5">
            <div class="flex-shrink-0">
              <img *ngIf="blog.acceptedCollaborators.length === 0" [src]="blog.avatar" [alt]="blog.authorDisplayName"
                class="w-15 h-15 rounded-full object-cover ring-2 ring-gray-100" />

              <div *ngIf="blog.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center cursor-pointer"
                (click)="showCollaboratorsModal(blog); $event.stopPropagation()">
                <img class="h-11 w-11 rounded-full border-2 border-white object-cover ring-2 ring-[#FFD4E0]"
                  [src]="blog.avatar" [alt]="blog.authorDisplayName"
                  onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
                <img class="h-8 w-8 rounded-full border-2 border-white object-cover"
                  [src]="blog.acceptedCollaborators[0].profileImage?.urlSmall"
                  [alt]="blog.acceptedCollaborators[0].displayName"
                  onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
              </div>
            </div>
            <div>
              <p class="font-semibold text-gray-900 text-md leading-tight break-words">{{ blog.title }}</p>
              <div class="text-md leading-tight">
                <span class="text-sm text-[#858585] font-normal">By </span>
                <span class="text-[#D31148] cursor-pointer" (click)="$event.stopPropagation()"
                  [routerLink]="['/profile', blog.author, 'blog']">{{ blog.author }}</span>

                <ng-container *ngIf="blog.acceptedCollaborators.length === 1">
                  <span class="text-sm text-[#858585] font-normal"> with </span>
                  <span class="text-[#D31148] cursor-pointer" (click)="$event.stopPropagation()"
                    [routerLink]="['/profile', blog.acceptedCollaborators[0].userName, 'blog']">
                    {{ blog.acceptedCollaborators[0].userName }}
                  </span>
                </ng-container>

                <ng-container *ngIf="blog.acceptedCollaborators.length >= 2">
                  <span class="text-sm text-[#858585] font-normal"> and </span>
                  <span class="font-semibold text-gray-700 cursor-pointer hover:text-gray-900"
                    (click)="showCollaboratorsModal(blog); $event.stopPropagation()">
                    {{ blog.acceptedCollaborators.length }} others
                  </span>
                </ng-container>
              </div>
              <p class="text-gray-400 text-sm mt-0.5">{{ blog.timeAgo }}</p>
            </div>
          </div>
          <div class="flex items-center gap-2" *ngIf="!blog.isMyBlog && blog.acceptedCollaborators.length === 0">
            <button (click)="onRecommendationFollowClick(blog, $event)"
              class="px-3 py-1.5 text-sm font-medium rounded-lg transition flex-shrink-0" [ngClass]="blog.isFollowed
                ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
              {{ blog.isFollowed ? 'Unfollow' : 'Follow' }}
            </button>

            <button (click)="onFriendButtonClick(blog, $event)" [disabled]="blog.friendshipStatus === 'BLOCKED'"
              [title]="friendButtonTitle(blog.friendshipStatus)"
              class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">
              <svg *ngIf="blog.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#D31148" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>
            </button>
          </div>
        </div>
        <div class="h-[2px] bg-[#DADADA] w-full px-4"></div>
        <div *ngIf="blog.images.length > 0" class="relative w-full overflow-hidden select-none"
          style="aspect-ratio: 4/3;" appSwipe [swipeDisabled]="blog.images.length <= 1"
          (swipeLeft)="onSlideSwipe(blog, 1)" (swipeRight)="onSlideSwipe(blog, -1)">
          <ng-container *ngIf="blog.images.length > 0">
            <ng-container *ngFor="let img of blog.images; let di = index; trackBy: trackByIndex">
              <img *ngIf="!isVideoSlide(blog, di)" [src]="img" alt="blog image"
                class="absolute inset-0 w-full pt-4 h-full object-cover transition-opacity duration-500"
                [class.opacity-100]="di === (blog.activeSlide)" [class.opacity-0]="di !== (blog.activeSlide)" />
              <video *ngIf="isVideoSlide(blog, di)" [src]="img" controls preload="metadata" playsinline
                class="absolute inset-0 w-full pt-4 h-full object-cover transition-opacity duration-500 bg-black"
                [class.opacity-100]="di === (blog.activeSlide)" [class.opacity-0]="di !== (blog.activeSlide)"
                (click)="$event.stopPropagation()">
              </video>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="blog.images.length > 1">
            <button (click)="prevSlide(blog, $event)"
              class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button (click)="nextSlide(blog, $event)"
              class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </ng-container>

          <button
            class="absolute top-6 right-2 z-10 w-9 h-9 rounded-full bg-[#ffffff] flex items-center justify-center shadow-lg transition-colors"
            (click)="toggleLike(blog, $event)">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-[#D31148]" viewBox="0 0 24 24"
              [attr.fill]="blog.myReaction === 'LIKE' ? 'currentColor' : 'none'" stroke="currentColor"
              stroke-width="1.5">
              <path
                d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
            </svg>
          </button>
        </div>

        <div *ngIf="blog.images.length > 1" class="flex items-center justify-center gap-1.5 pt-3 pb-1">
          <button *ngFor="let img of blog.images; let di = index; trackBy: trackByIndex"
            (click)="goToSlide(blog, di); $event.stopPropagation()"
            class="rounded-full transition-all duration-300 focus:outline-none" [style.height]="'8px'"
            [style.width]="di === (blog.activeSlide) ? '20px' : '8px'"
            [style.background-color]="di === (blog.activeSlide) ? '#e0144c' : '#d1d5db'"
            [attr.aria-label]="'Go to slide ' + (di + 1)"></button>
        </div>

        <div *ngIf="blog.images.length === 1" class="pt-3 pb-1"></div>

        <div class="pb-2 flex-1" [class.pt-4]="blog.images.length === 0" [class.pt-2]="blog.images.length > 0">
          <p class="text-gray-700 text-sm leading-relaxed line-clamp-4">
            {{ blog.text }}
            <span *ngIf="blog.hasMore" class="text-[#e0144c] font-semibold cursor-pointer hover:underline"> Read
              More</span>
          </p>
        </div>

        <ng-container *ngIf="blog.totalReactions > 0">
          <button class="flex items-center mt-2 gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
            (click)="openReactionModal(blog, $event); $event.stopPropagation()">
            <span class="flex items-center" style="gap:-4px;">
              <span *ngFor="let t of blog.topTypes; let i = index"
                class="flex items-center justify-center rounded-full border-2 border-white shadow-sm"
                [style.background]="getReactionConfig(t)?.bg" [style.width]="'22px'" [style.height]="'22px'"
                [style.font-size]="'13px'" [style.line-height]="'1'" [style.margin-left]="i > 0 ? '-6px' : '0'"
                [style.z-index]="10 - i">
                {{ getReactionConfig(t)?.emoji }}
              </span>
            </span>
            <span class="text-sm text-gray-500">
              <ng-container *ngIf="blog.recentUserName">
                <span class="font-medium text-gray-700">{{ blog.recentUserName }}</span>
                <ng-container *ngIf="blog.totalReactions > 1">
                  and {{ blog.totalReactions - 1 }} {{ blog.totalReactions - 1 === 1 ? 'other' : 'others' }}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!blog.recentUserName">
                {{ blog.totalReactions }}
              </ng-container>
            </span>
          </button>
        </ng-container>

        <div class="flex items-center justify-between pb-4 pt-2" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-4 text-gray-500 text-sm">
            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
              <div *ngIf="blog.showEmojiPicker"
                class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;" (mouseleave)="closeEmojiPicker(blog)">
                <button *ngFor="let r of REACTIONS; let ri = index" (click)="onEmojiPick(blog, r.type, $event)"
                  (mouseenter)="blog.hoveredReaction = r.type" (mouseleave)="blog.hoveredReaction = null"
                  class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                  [style.animation-delay.ms]="ri * 30" [title]="r.label">
                  <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                    [class.scale-125]="blog.hoveredReaction === r.type"
                    [class.-translate-y-2]="blog.hoveredReaction === r.type"
                    style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                    {{ r.emoji }}
                  </span>
                </button>
              </div>

              <button
                class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90 hover:text-[#e0144c]"
                (click)="onReactionClick(blog)">
                <ng-container *ngIf="!blog.myReaction">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g opacity="0.7">
                      <path
                        d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                      <path
                        d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg>
                  <span>{{ blog.totalReactions }}</span>
                </ng-container>
                <ng-container *ngIf="blog.myReaction">
                  <span class="reaction-bounce flex items-center justify-center rounded-full"
                    [style.background]="getReactionConfig(blog.myReaction)?.bg"
                    style="width:30px;height:30px;font-size:18px;line-height:1;">
                    {{ getReactionConfig(blog.myReaction)?.emoji }}
                  </span>
                  <span class="font-semibold" [style.color]="getReactionConfig(blog.myReaction)?.color">
                    {{ blog.reactions }}
                  </span>
                </ng-container>
              </button>
            </div>

            <button class="flex items-center gap-1.5 hover:text-[#e0144c] transition-colors">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              <span>{{ blog.comments }}</span>
            </button>

            <button class="flex items-center gap-1.5 hover:text-[#e0144c] transition-colors">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                    stroke="#858585" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              <span>{{ blog.shares }}</span>
            </button>
          </div>

          <button class="w-10 h-10 rounded-full flex items-center justify-center shadow-md flex-shrink-0
                            bg-[radial-gradient(circle,_#DA3D6A_80%,_#D35266_100%)]
                            hover:bg-[radial-gradient(circle,_#c7365e_80%,_#b84456_100%)]
                            transition-colors" (click)="openReactionModal(blog, $event)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.99121 15.4084V6.94169C6.99121 6.60835 7.09121 6.28335 7.27454 6.00835L9.54954 2.62502C9.90788 2.08335 10.7995 1.70002 11.5579 1.98335C12.3745 2.25835 12.9162 3.17502 12.7412 3.99169L12.3079 6.71669C12.2745 6.96669 12.3412 7.19169 12.4829 7.36669C12.6245 7.52502 12.8329 7.62502 13.0579 7.62502H16.4829C17.1412 7.62502 17.7079 7.89169 18.0412 8.35835C18.3579 8.80835 18.4162 9.39169 18.2079 9.98335L16.1579 16.225C15.8995 17.2584 14.7745 18.1 13.6579 18.1H10.4079C9.84954 18.1 9.06621 17.9084 8.70788 17.55L7.64121 16.725C7.23288 16.4167 6.99121 15.925 6.99121 15.4084Z"
                fill="white" />
              <path
                d="M4.34199 5.31665H3.48366C2.19199 5.31665 1.66699 5.81665 1.66699 7.04998V15.4333C1.66699 16.6666 2.19199 17.1666 3.48366 17.1666H4.34199C5.63366 17.1666 6.15866 16.6666 6.15866 15.4333V7.04998C6.15866 5.81665 5.63366 5.31665 4.34199 5.31665Z"
                fill="white" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section> -->

<app-modal [isOpen]="isReactionOpen" (close)="closeReactionModal()" className="max-w-[700px]">
  <div class="relative w-full h-full flex flex-col bg-white rounded-3xl overflow-hidden">
    <div class="flex-shrink-0 bg-white border-b border-[#f0f0f0]">
      <div class="flex items-center gap-1 overflow-x-auto px-5 pt-5 pb-3 lg:px-8">
        <button (click)="setReactionFilter(null)"
          class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
          [class.text-[#D31148]]="activeReactionFilter === null" [class.border-b-2]="activeReactionFilter === null"
          [class.border-[#D31148]]="activeReactionFilter === null"
          [class.text-gray-500]="activeReactionFilter !== null">
          All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
        </button>
        <ng-container *ngFor="let r of REACTIONS">
          <button (click)="setReactionFilter(r.type)"
            class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
            [class.text-[#D31148]]="activeReactionFilter === r.type"
            [class.border-b-2]="activeReactionFilter === r.type"
            [class.border-[#D31148]]="activeReactionFilter === r.type"
            [class.text-gray-500]="activeReactionFilter !== r.type">
            <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
            <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="flex-1 overflow-y-auto px-5 py-4 lg:px-8">
      <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
      </div>
      <div *ngIf="!reactionsLoading" class="space-y-1">
        <div *ngFor="let item of filteredReactions"
          class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
          <div class="relative flex-shrink-0">
            <img [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
              class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]" [alt]="item.user?.displayName" />
            <span
              class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
              [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.userName }}</div>
            <div class="text-xs text-gray-400 truncate">{{ item.user?.displayName }}</div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
              [title]="friendButtonTitle(item.friendship?.status ?? 'NONE')"
              [disabled]="item.friendship?.status === 'BLOCKED'"
              class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
              [ngClass]="item.friendship?.status === 'FRIENDS'
                ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                : item.friendship?.status === 'PENDING_SENT'
                  ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                  : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">
              <svg *ngIf="!item.friendship?.status || item.friendship?.status === 'NONE'" width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
              <svg *ngIf="item.friendship?.status === 'PENDING_SENT'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>
              <svg *ngIf="item.friendship?.status === 'PENDING_RECEIVED'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="item.friendship?.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
            </button>

            <button *ngIf="!item.isMe" (click)="onModalFollowClick(item, $event)"
              class="px-3 py-1.5 rounded-lg text-xs font-bold transition-colors shadow-sm" [ngClass]="item.isFollowed
                ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                : 'bg-[#D31148] text-white hover:bg-[#b80e3d]'">
              {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
            </button>
          </div>
        </div>

        <div *ngIf="filteredReactions.length === 0" class="py-10 text-center text-gray-400 text-sm">
          No reactions yet
        </div>
      </div>
    </div>
  </div>
</app-modal>

<!-- Collaborators modal -->
<div *ngIf="showCollabModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
  (click)="closeCollaboratorsModal()">
  <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-gray-200 p-4">
      <h3 class="text-lg font-bold">Collaborators</h3>
      <button (click)="closeCollaboratorsModal()" class="text-gray-400 transition-colors hover:text-gray-600">
        <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
      <!-- Host row -->
      <div class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
        [routerLink]="['/profile', selectedBlog?.hostName, 'blog']">
        <img [src]="selectedBlog?.hostAvatar" [alt]="selectedBlog?.hostName || 'Author'"
          class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
          onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
        <div class="min-w-0 flex-1">
          <div class="truncate font-semibold text-gray-900">{{ selectedBlog?.hostName }}</div>
          <div class="text-sm text-gray-500">Author</div>
        </div>
      </div>

      <!-- Collaborator rows -->
      <div *ngFor="let collab of selectedBlog?.acceptedCollaborators"
        class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
        [routerLink]="['/profile', collab.userName, 'blog']">
        <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
          class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
          onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
        <div class="min-w-0 flex-1">
          <div class="truncate font-semibold text-gray-900">@{{ collab.userName }}</div>
          <div class="truncate text-sm text-gray-500">{{ collab.displayName }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tagged people modal -->
<div *ngIf="showTaggedModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
  (click)="closeTaggedPeopleModal()">
  <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-gray-200 p-4">
      <h3 class="text-lg font-bold">Tagged People</h3>
      <button (click)="closeTaggedPeopleModal()" class="text-gray-400 transition-colors hover:text-gray-600">
        <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
      <div *ngFor="let tagged of selectedBlog?.mentions"
        class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50 cursor-pointer"
        [routerLink]="['/profile', tagged.userName, 'blog']">
        <img [src]="tagged.profileImage?.urlSmall" [alt]="tagged.displayName"
          class="h-12 w-12 rounded-full border-2 border-white object-cover flex-shrink-0"
          onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
        <div class="min-w-0 flex-1">
          <div class="truncate font-semibold text-gray-900">@{{ tagged.userName }}</div>
          <div class="truncate text-sm text-gray-500">{{ tagged.displayName }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirmation-popup [isOpen]="showLoginPrompt" icon="user-add" title="Login Required"
  [message]="'To ' + loginPromptAction" [highlightedName]="loginPromptUserName"
  messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close" (confirmed)="goToLogin()"
  (cancelled)="closeLoginPrompt()">
</app-confirmation-popup>

<app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
  (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

<app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
  message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
  (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

<!-- Delete blog confirmation -->
<app-confirmation-popup [isOpen]="showDeleteConfirm" icon="warning" title="Delete Blog"
  message="Are you sure you want to permanently delete this blog? All media will also be removed." confirmLabel="Delete"
  cancelLabel="Cancel" (confirmed)="doDeleteBlog()" (cancelled)="cancelDelete()">
</app-confirmation-popup>

<!-- Leave blog collaboration confirmation -->
<app-confirmation-popup [isOpen]="showLeaveConfirm" icon="warning" title="Leave Collaboration"
  message="Are you sure you want to remove yourself from this blog collaboration?" confirmLabel="Leave"
  cancelLabel="Cancel" (confirmed)="doLeaveCollaboration()" (cancelled)="cancelLeave()">
</app-confirmation-popup>

<!-- Report Blog -->
<app-report-modal [isOpen]="isReportModalOpen" targetLabel="Blog" [isSubmitting]="isSubmittingReport"
  [errorMessage]="reportError" (submitted)="submitBlogReport($event)" (cancelled)="closeReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="reportSuccessOpen" icon="info" title="Report Submitted"
  message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
  (cancelled)="closeReportSuccess()"></app-confirmation-popup>

<!-- Block User (safeword-confirm) -->
<app-block-user-confirm [isOpen]="showBlockUserConfirm" [targetName]="blogAuthorDisplayName"
  (confirmed)="confirmBlockBlogUser()" (cancelled)="cancelBlockBlogUser()"></app-block-user-confirm>

<!-- Report Comment -->
<app-report-modal [isOpen]="isCommentReportModalOpen" targetLabel="Comment" [isSubmitting]="isSubmittingCommentReport"
  [errorMessage]="commentReportError" (submitted)="submitCommentReport($event)" (cancelled)="closeCommentReportModal()">
</app-report-modal>

<app-confirmation-popup [isOpen]="commentReportSuccessOpen" icon="info" title="Report Submitted"
  message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
  (cancelled)="closeCommentReportSuccess()"></app-confirmation-popup>

<style>
  /* ── Rich blog content ───────────────────────────────────────────────────── */
  ::ng-deep .blog-prose {
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  ::ng-deep .blog-prose p {
    margin-bottom: 1rem;
  }

  ::ng-deep .blog-prose h1 {
    font-size: 1.875rem;
    font-weight: 700;
    margin-bottom: .75rem;
    color: #111827;
  }

  ::ng-deep .blog-prose h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: .75rem;
    color: #111827;
  }

  ::ng-deep .blog-prose h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: .5rem;
    color: #111827;
  }

  ::ng-deep .blog-prose h4 {
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: .5rem;
    color: #111827;
  }

  ::ng-deep .blog-prose h5 {
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: .5rem;
    color: #111827;
  }

  ::ng-deep .blog-prose h6 {
    font-size: .875rem;
    font-weight: 600;
    margin-bottom: .5rem;
    color: #111827;
  }

  ::ng-deep .blog-prose ul {
    list-style: disc;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  ::ng-deep .blog-prose ol {
    list-style: decimal;
    padding-left: 1.5rem;
    margin-bottom: 1rem;
  }

  ::ng-deep .blog-prose li {
    margin-bottom: .25rem;
  }

  ::ng-deep .blog-prose a {
    color: #D31148;
    text-decoration: underline;
  }

  ::ng-deep .blog-prose blockquote {
    border-left: 4px solid #D31148;
    padding: 8px 16px;
    margin: 1rem 0;
    color: #555;
    font-style: italic;
    background: #fff5f7;
    border-radius: 0 6px 6px 0;
  }

  ::ng-deep .blog-prose pre {
    background: #f4f4f4;
    padding: 12px 16px;
    border-radius: 6px;
    font-family: monospace;
    font-size: .875rem;
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb;
    overflow-x: auto;
    white-space: pre-wrap;
  }

  ::ng-deep .blog-prose code {
    font-family: monospace;
    font-size: .875rem;
    background: #f4f4f4;
    padding: 2px 4px;
    border-radius: 3px;
  }

  ::ng-deep .blog-prose img {
    max-width: 100%;
    height: auto;
    border-radius: 6px;
    margin: .5rem 0;
    display: block;
  }

  ::ng-deep .blog-prose video {
    max-width: 100%;
    border-radius: 6px;
    margin: .5rem 0;
    display: block;
  }

  ::ng-deep .blog-prose table {
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;
  }

  ::ng-deep .blog-prose td,
  ::ng-deep .blog-prose th {
    border: 1px solid #d1d5db;
    padding: 8px 12px;
    text-align: left;
  }

  ::ng-deep .blog-prose th {
    background: #f9fafb;
    font-weight: 600;
  }

  ::ng-deep .blog-prose hr {
    border: none;
    border-top: 2px solid #e5e7eb;
    margin: 1.5rem 0;
  }

  ::ng-deep .blog-prose sub {
    vertical-align: sub;
    font-size: smaller;
  }

  ::ng-deep .blog-prose sup {
    vertical-align: super;
    font-size: smaller;
  }

  /* ── Comment body ────────────────────────────────────────────────────────── */
  ::ng-deep .comment-body a {
    color: #D31148;
    text-decoration: underline;
  }

  ::ng-deep .comment-body img {
    max-width: 100%;
    border-radius: 6px;
    margin: .25rem 0;
  }

  /* ── Mention ─────────────────────────────────────────────────────────────── */
  ::ng-deep .mention-highlight {
    color: #2563eb !important;
    font-weight: 700 !important;
  }

  .mention-editable {
    min-height: 20px;
    max-height: 120px;
    overflow-y: auto;
  }

  .mention-editable:empty:before {
    content: attr(data-placeholder);
    color: #9ca3af;
    pointer-events: none;
  }

  .mention-editable:focus:before {
    content: '';
  }

  .mention-editable .mention {
    color: #2563eb;
    font-weight: 700;
    background: #eff6ff;
    padding: 0 2px;
    border-radius: 2px;
  }
</style>

<app-share-sheet *ngIf="shareConfig" [config]="shareConfig" [currentCount]="shareCount" (closed)="closeShareSheet()"
  (countUpdated)="onShareCountUpdated($event)">
</app-share-sheet>